import React from 'react';
import { connect } from 'react-redux';

import OsteotomyStep10 from './osteotomy-step10/OsteotomyStep10';
import CmfExtendedStep10 from './cmf-extended-step10/CmfExtendedStep10';

import { updateCase } from '../../../../../actions/casesActions';

import { caseConstants } from '../../../../../constants';

const {
  procedureFlows,
  fileTypes,
  statuses,
  caseCMFExtendedNotifications,
  cmfExtendedProcedureFlows
} = caseConstants;

const Step10 = ({ classes, onClose, activeCase, userId, updateCase, products }) => {
  const renderStep10 = (flow) => {
    if ([procedureFlows.HTO, procedureFlows.DFO_Medial, procedureFlows.DFO_Lateral, procedureFlows.CUSTOM, procedureFlows.HTO_LATERAL].includes(flow)) {
      return (
        <OsteotomyStep10
          classes={classes}
          activeCase={activeCase}
          onClose={onClose}
        />
      );
    }

    if (cmfExtendedProcedureFlows.includes(flow)) {
      return (
        <CmfExtendedStep10
          classes={classes}
          onClose={onClose}
          activeCase={activeCase}
          updateCase={updateCase}
          products={products}
          caseNotifications={caseCMFExtendedNotifications}
          fileTypes={fileTypes}
          statuses={statuses}
          userId={userId}
        />
      );
    }
  };

  return renderStep10(activeCase.procedureFlow);
};

const mapStateToProps = (state) => {
  const activeCase = state.cases.activeCase;
  const procedure = state.procedures.list.find((procedure) => procedure.id === activeCase.procedure);
  const products = procedure ? procedure.products : [];

  return {
    activeCase,
    userId: state.user.currentUser.uid,
    products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCase: (newCase, newFiles) => dispatch(updateCase(newCase, 10, newFiles)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Step10);
